import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  containerOffsetForm: {
    padding: 10,
  },
  rootOffset: {
    borderRadius: '20px',
    border: '4px solid #82c56b',
    borderTopColor: '#82c56b',
    borderBottomColor: '#80ca5a',
  },
  containerTextOffset: {
    color: theme.palette.text.tertiary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    borderTop: '4px solid #80ca5a',
    [theme.breakpoints.up('md')]: {
      paddingLeft: '15px',
      paddingRight: '15px',
    },

    [theme.breakpoints.up('sm')]: {
      paddingLeft: '15px',
      paddingRight: '15px',
    },
    [theme.breakpoints.up('xs')]: {
      paddingLeft: '15px',
      paddingRight: '15px',
    },
  },
  rootCertificate: {
    borderRadius: '20px',
    border: '4px solid #4afcff',
    borderTopColor: '#4afcff',
    borderBottomColor: '#4dfdfa',
  },
  containerTextCertificate: {
    color: theme.palette.text.tertiary,

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    borderTop: '4px solid #4afcff',
    [theme.breakpoints.up('md')]: {
      paddingLeft: '15px',
      paddingRight: '15px',
    },

    [theme.breakpoints.up('sm')]: {
      paddingLeft: '15px',
      paddingRight: '15px',
    },
    [theme.breakpoints.up('xs')]: {
      paddingLeft: '15px',
      paddingRight: '15px',
    },
  },
  nameProject:{
    color: theme.palette.text.tertiary,
    fontFamily: 'MontserratLight',
fontSize:'1.6em',
[theme.breakpoints.down('md')]: {
  fontSize:'1.4em',
},

[theme.breakpoints.down('sm')]: {
  fontSize:'1.4em',

},
[theme.breakpoints.down('xs')]: {
  fontSize:'1.6em'

}

  },
  urlCarbonCredit: {
    textDecoration: 'none',
 
  },
  nameProjectHash:{ 
     color: theme.palette.text.tertiary,
       fontFamily: 'MontserratRegular',
       fontSize:'1.4em',
       [theme.breakpoints.down('md')]: {
        fontSize:'1.2em'
      
      },
      
      [theme.breakpoints.down('sm')]: {
        fontSize:'1.2em'
      
      },
      [theme.breakpoints.down('xs')]: {
        fontSize:'1.4em'
      
      }
  },
  containerLabelsOffsetForm: {
    // width: '100%',
    paddingBottom: '0px !important',
    marginBottom: '0px !important',
    textAlign: 'left',
  },
  textFieldOffsetForm: {
    width: '100%',
    color: theme.palette.text.tertiary,
    fontFamily: 'Montserrat !important',
    '&:focus': {
      border: `1px solid ${theme.palette.text.tertiary}`,
    },
    '& .MuiInputBase-input': {
      border: `1px solid ${theme.palette.text.tertiary}`,
      borderRadius: 6,
      backgroundColor: '#42c40a00 !important',
    },
    '&.Mui-focused fieldset': {
      border: 'none',
    },
  },
  textFieldOffsetDate: {
    width: '100%',
    color: theme.palette.text.tertiary,
    fontFamily: 'Montserrat !important',
  },

  labelsOffsetForm: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '21px',
    color: theme.palette.text.tertiary,
  },
  buttonOffsetForm: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  dateOffsetForm: {
    color: theme.palette.text.tertiary,
    padding: '5px 0px 0px 2px',
    // border: '1px solid #D9D9D9',
    border: `1px solid ${theme.palette.text.tertiary}`,
    borderRadius: 6,
    width: '100%',
  },
  textFieldNotchedOutline: {
    border: 'none',
  },
  iconOffsetForm: {
    color: theme.palette.text.tertiary,
  },
  paper: {
    '&.MuiPaper-root': {
      // color: '#D9D9D9',
      color: theme.palette.text.tertiary,
      fontFamily: 'Montserrat !important',
    },
    '& .MuiPickersDay-day': {
      color: theme.palette.text.tertiary,
      fontFamily: 'Montserrat !important',
    },
    '& .MuiPickersCalendarHeader-dayLabel': {
      color: theme.palette.text.tertiary,
      fontFamily: 'Montserrat !important',
    },
    '& .MuiPickersDay-dayDisabled': {
      color: 'rgba(0, 0, 0, 0.38)',
      fontFamily: 'Montserrat !important',
    },

    '& .MuiSvgIcon-root': {
      // fill: '#D9D9D9',
      fill: theme.palette.text.tertiary,
      fontFamily: 'Montserrat !important',
    },
  },
  customOutlinedInput: {
    marginTop: 3,
    fontFamily: 'Montserrat !important',

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.text.tertiary,
      fontFamily: 'Montserrat !important',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.text.tertiary,
    },
    '&:focus .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.text.tertiary,
    },
    '& .Mui-focused': {
      outline: 'none',
    },
    '&:active .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.text.tertiary,
    },
  },
  disabledDatePicker: {
    '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderColor: '#888  !important',
    },
    '& .MuiInputBase-root.Mui-disabled': {
      color: '#888',
    },
    '& .MuiInputLabel-root.Mui-disabled': {
      color: '#888 !important',
    },
  },
  imgCarbonCarmedia: {
    position: 'relative',
  },
  conteainerCheckboxCarbon: {
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'flex-start',
  },
  customButton: {
    '&.Mui-disabled': {
      color: '#6d6d6d',
      boxShadow: 'none',
      backgroundColor: '#aaaaaa',
    },
  },
  drawerTransparentBackground: {
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
  },
  hashContent:{
    marginTop:30
  },
  subtitleNameProject:{
    fontFamily: 'Montserrat',
    fontWeight:600

  }

}));

export default useStyles;
